import React from 'react';

import { BudgetMemberCalculations, formatBudgetCalculationAmount } from '@/utils/budgetCalculations';

interface BudgetMemberCalculationsFooterProps {
  calculations: BudgetMemberCalculations | null;
}

const BudgetMemberCalculationsFooter: React.FC<BudgetMemberCalculationsFooterProps> = ({ calculations }) => {
  if (!calculations) {
    return null;
  }

  if (calculations.allOreHoursFilled && calculations.bhov != null && calculations.btev != null) {
    return (
      <div className="space-y-4 w-full flex-1 bg-white md:bg-none rounded-[16px] p-4 md:p-0">
        <p className="text-xs md:text-sm flex items-center gap-2 justify-between md:justify-start text-secondary font-medium">
          <span>Budget Hours Operative Value (BHOV) </span>
          <span className="text-gray font-bold text-sm md:text-base">
            {formatBudgetCalculationAmount(calculations.bhov, calculations.currency)}
          </span>
        </p>
        <p className=" flex items-center gap-2 justify-between md:justify-start text-secondary font-medium">
          <span className="text-sm md:text-base">Budget Total Expense Value (BTEV) </span>
          <span className="text-gray font-bold text-base md:text-[20px]">
            {formatBudgetCalculationAmount(calculations.btev, calculations.currency)}
          </span>
        </p>
      </div>
    );
  }

  if (calculations.hasPartialOreHours) {
    return (
      <p className="text-sm text-secondary max-w-md">
        Enter ore hours for all members to see the calculated BHOV and BTEV.
      </p>
    );
  }

  return (
    <p className="text-sm text-secondary max-w-md">
      Enter ore hours for all members to see the calculated BHOV and BTEV.
    </p>
  );
};

export default BudgetMemberCalculationsFooter;
